// extracted by mini-css-extract-plugin
var _1 = "ApplicantCreditCheckSuggestion-moduledocumentLabel__cgX4P ApplicantCreditCheckBlock-moduledocumentLabel__bKVxW";
var _2 = "ApplicantCreditCheckSuggestion-moduleline__kdM3N ApplicantCreditCheckBlock-moduleline__iu1fZ";
var _3 = "ApplicantCreditCheckSuggestion-modulelines__Ua08l ApplicantCreditCheckBlock-modulelines__q84pP";
var _4 = "ApplicantCreditCheckSuggestion-modulesuggestionActions__imNTM";
var _5 = "ApplicantCreditCheckSuggestion-modulesuggestionBody__kKngi";
var _6 = "ApplicantCreditCheckSuggestion-modulesuggestionFile__os_9c";
var _7 = "ApplicantCreditCheckSuggestion-modulesuggestionHead__puX3C";
export { _1 as "documentLabel", _2 as "line", _3 as "lines", _4 as "suggestionActions", _5 as "suggestionBody", _6 as "suggestionFile", _7 as "suggestionHead" }
